/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface BulletinDetailSearch
 */
export interface BulletinDetailSearch {
    /**
     * 
     * @type {number}
     * @memberof BulletinDetailSearch
     */
    idbulletinApprenantType?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulletinDetailSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof BulletinDetailSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof BulletinDetailSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulletinDetailSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof BulletinDetailSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof BulletinDetailSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the BulletinDetailSearch interface.
 */
export function instanceOfBulletinDetailSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulletinDetailSearchFromJSON(json: any): BulletinDetailSearch {
    return BulletinDetailSearchFromJSONTyped(json, false);
}

export function BulletinDetailSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulletinDetailSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idbulletinApprenantType': !exists(json, 'idbulletinApprenantType') ? undefined : json['idbulletinApprenantType'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function BulletinDetailSearchToJSON(value?: BulletinDetailSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idbulletinApprenantType': value.idbulletinApprenantType,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

